import React, { useEffect, useState } from 'react';
import { Card, Section } from '../Card';
import Button from '../Button';
import { EmptyState, ErrorState } from '../States';
import { SkeletonList } from '../Skeleton';
import AgendaMotionRow from './AgendaMotionRow';
import { AgendaMotionData, loadAgendaMotionData } from './agendaMotions';

const PREVIEW = 5;

/* The MK page's activity tab, "הצעות לסדר" tile selected (5a): the motions the MK moved in
   Knesset `knesset` (alone or in a combined motion), newest first. The list of an archived
   Knesset comes from its archive. */
const MemberAgendaMotions = ({ memberId, knesset, name }: { memberId: string; knesset: number; name: string }) => {
  const [data, setData] = useState<AgendaMotionData | null>(null);
  const [error, setError] = useState(false);
  const [reloadKey, setReloadKey] = useState(0);
  const [showAll, setShowAll] = useState(false);

  useEffect(() => {
    let cancelled = false;
    setError(false);
    setData(null);
    loadAgendaMotionData(knesset)
      .then(d => { if (!cancelled) setData(d); })
      .catch(() => { if (!cancelled) setError(true); });
    return () => { cancelled = true; };
  }, [knesset, reloadKey]);

  if (error) return <Card padding={0}><ErrorState onRetry={() => setReloadKey(k => k + 1)} /></Card>;
  if (!data) return <SkeletonList rows={3} />;

  const mine = data.motions.filter(m => m.mkIds.indexOf(memberId) >= 0);
  if (mine.length === 0) {
    return <Card padding={0}><EmptyState icon="document" title="אין הצעות לסדר היום" body={`לא נמצאו הצעות לסדר היום שהגיש/ה ${name} בכנסת ה-${knesset}.`} /></Card>;
  }
  const visible = showAll ? mine : mine.slice(0, PREVIEW);
  return (
    <Section title="הצעות לסדר היום" meta={mine.length}>
      <Card padding={0}>
        {visible.map((m, i) => (
          <AgendaMotionRow key={m.id} motion={m} members={data.members} committees={data.committees} divider={i > 0} from={name} />
        ))}
      </Card>
      {mine.length > PREVIEW && (
        <Button fullWidth onClick={() => setShowAll(!showAll)}>
          {showAll ? `הצגת ${PREVIEW} האחרונות בלבד` : `הצגת כל ${mine.length} ההצעות`}
        </Button>
      )}
    </Section>
  );
};

export default MemberAgendaMotions;
